import { render, staticRenderFns } from "./class1.vue?vue&type=template&id=6df46e18&scoped=true&"
import script from "./class1.vue?vue&type=script&lang=js&"
export * from "./class1.vue?vue&type=script&lang=js&"
import style0 from "./class1.vue?vue&type=style&index=0&id=6df46e18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df46e18",
  null
  
)

export default component.exports